import { render, staticRenderFns } from "./proportionTable.vue?vue&type=template&id=66cc0cb1"
import script from "./proportionTable.vue?vue&type=script&lang=js"
export * from "./proportionTable.vue?vue&type=script&lang=js"
import style0 from "./proportionTable.vue?vue&type=style&index=0&id=66cc0cb1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports